import DropViewState from 'owa-dnd/lib/store/schema/DropViewState';
import getSelectedFolderViewState from './getSelectedFolderViewState';

export default function getDragToEndOfListDropViewState(): DropViewState {
    const folderViewState = getSelectedFolderViewState();

    return folderViewState !== null ? folderViewState.dragToEndDropViewState : null;
}
